export interface TabType {
  path: string;
  label: string;
}

export const tabs: TabType[] = [
  { path: 'work', label: 'Work' },
  { path: 'about', label: 'About' },
  { path: 'contact', label: 'Contact' },
];

export const title = 'Yoav Reches';

export const siteUrl = 'https://yoav-reches.com';

export const s3Url = "'https://nayo-website.s3.amazonaws.com/info.json'";

export const imageKitUrl = 'https://ik.imagekit.io/nayo';

/**
 * ---------------------------------------------------------------------------
 * TO SET before merging: the studio contact address.
 *
 * This single value drives the Contact page and the press enquiry line on the
 * CV page. Replace it with the address that should receive enquiries from
 * press, galleries and collectors.
 * ---------------------------------------------------------------------------
 */
export const contactEmail = 'yoav.at.nayo.info';

export const contactEmailIsSet = !contactEmail.includes('REPLACE_ME');
